module.exports = __webpack_public_path__ + "img/sh.684f17de.png";